import { IValue } from './ivalue';
import { ControlType } from '../controltype';
import { EventEmitter } from '@angular/core';
export class CheckboxGroupValue implements IValue {
    clear$ = new EventEmitter();
    valueChanged = new EventEmitter();
    value: any[];
    constructor(value: any[] = []) {
        this.value = value;
    }
    isEmpty(): boolean {
        return this.value.length == 0;
    }

    clearValue(): void {
        this.value = [];
        this.clear$.emit();
    }
    setOriginalValue(value: any[]): void {
        this.value = value;
    }

    setValue(value: any) {
        this.value = value;
        this.valueChanged.emit(this.value);
    }

    getOriginalValue() {
        return this.value;
    }
    getControlType(): ControlType {
        return ControlType.CheckboxGroup;
    }
}
